var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timeline-images hide-scrollbar"},_vm._l((_vm.images),function(image){return _c('item-gallery-list-item',{key:image.id,attrs:{"image":image}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }